export const mapConstants = {
  enablePointSelectionZoomLevels: {
    minimum: 9,
  },
  unadoptedLayerId: 'unadoptedLayer',
};
